import Reveal from "@stimulus-components/reveal";

export default class extends Reveal {
  static values = {
    closeOthers: { type: Boolean, default: true },
  };

  toggle(event, closeOthers = this.closeOthersValue) {
    if (closeOthers) {
      this.closeOthers();
    }

    super.toggle();
    document.querySelectorAll("textarea").forEach((textarea) => {
      this.application
        .getControllerForElementAndIdentifier(textarea, "textarea-autogrow")
        ?.autogrow();
    });
    if (event) {
      event.currentTarget.classList.toggle("active");
    }
  }

  closeOthers() {
    const allRevealElements = document.querySelectorAll(
      '[data-controller*="reveal"]',
    );

    allRevealElements.forEach((element) => {
      if (element === this.element) return;

      const controller = this.application.getControllerForElementAndIdentifier(
        element,
        "reveal",
      );

      if (controller && controller !== this) {
        const editItem = controller.itemTargets[1];

        if (
          editItem &&
          !editItem.classList.contains(controller.hiddenClassValue || "hidden")
        ) {
          controller.toggle(null, false);
        }
      }
    });
  }

  submit(event) {
    event.currentTarget.form.requestSubmit();
    this.toggle(event);
  }

  submitOnEnter(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      event.currentTarget.form.requestSubmit();
      this.toggle(event);
    }
  }

  submitOnShiftAndEnter(event) {
    if (event.key === "Enter" && event.shiftKey) {
      event.preventDefault();
      event.currentTarget.form.requestSubmit();
      this.toggle(event);
    }
  }

  submitAndToggle(event) {
    event.preventDefault();
    const form = this.element.querySelector("form");
    if (form) {
      form.requestSubmit();
    }
    this.toggle(event);
  }
}
